import React from 'react';
import { Box, LinearProgress, Typography } from '@mui/material';

export const transcriptionStageLabel = (stage) => ({
  preparing: 'Preparing transcription...',
  transcribing: 'Transcribing recording...',
  saving: 'Saving transcription...',
}[stage] || 'Processing recording...');

export default function RecordingProgress({ stage, isUploading = false, progress }) {
  if (!stage && !isUploading) return null;
  const percent = !stage && progress?.total > 0
    ? Math.max(0, Math.min(100, Math.round((progress.loaded / progress.total) * 100)))
    : null;
  const label = stage ? transcriptionStageLabel(stage)
    : percent === null ? 'Preparing upload...'
    : percent === 100 ? 'Finishing upload...' : `Uploading recording... ${percent}%`;
  return (
    <Box sx={{ width: '100%', minWidth: 240, mb: 1.5 }}>
      <Typography variant="body2" role="status" sx={{ mb: 1 }}>{label}</Typography>
      <LinearProgress
        aria-label={label}
        variant={percent === null || percent === 100 ? 'indeterminate' : 'determinate'}
        {...(percent !== null && percent < 100 ? { value: percent } : {})}
      />
      {stage === 'transcribing' && (
        <Typography variant="caption" sx={{ color: 'text.secondary', display: 'block', mt: 0.5 }}>
          Longer recordings may take several minutes. Keep this page open.
        </Typography>
      )}
    </Box>
  );
}
